import { render, staticRenderFns } from "./list-skeleton.vue?vue&type=template&id=10c6b820&scoped=true"
import script from "./list-skeleton.vue?vue&type=script&lang=js"
export * from "./list-skeleton.vue?vue&type=script&lang=js"
import style0 from "./list-skeleton.vue?vue&type=style&index=0&id=10c6b820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6b820",
  null
  
)

export default component.exports